import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  border: 1px solid ${({ theme }) => theme.colors.neutral.cinza200};
  border-radius: 8px;

  padding: 16px;
  margin-bottom: 20px;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  span {
    font-size: 14px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.primary.vividCerulean};
  }

  hr {
    border: none;
    border-top: 1px solid ${({ theme }) => theme.colors.neutral.cinza200};
    width: 100%;
  }
`;

export const File = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  font-size: 13px;
`;

export const LinkHint = styled.p`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.neutral.cinza700};
`;

export const LinkFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  max-width: 520px;

  input {
    border: 1px solid ${({ theme }) => theme.colors.neutral.cinza200};
    border-radius: 6px;

    padding: 8px 10px;
    font-size: 13px;

    color: ${({ theme }) => theme.colors.neutral.cinza900};
  }
`;

export const LinkError = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.feedbackState.critical.default};
`;

export const Buttons = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`;
